import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from '@/pages/Landing';
import Landing2 from '@/pages/Landing2';
import AppLayout from '@/pages/AppLayout';
import Dashboard from '@/pages/app/Dashboard';
import Transactions from '@/pages/app/Transactions';
import Budgets from '@/pages/app/Budgets';
import Credits from '@/pages/app/Credits';
import Goals from '@/pages/app/Goals';
import Family from '@/pages/app/Family';
import Business from '@/pages/app/Business';
import Properties from '@/pages/app/Properties';
import PersonalProjects from '@/pages/app/PersonalProjects';
import IncomeUnits from '@/pages/app/IncomeUnits';
import MonthlyXray from '@/pages/app/MonthlyXray';
import Agenda from '@/pages/app/Agenda';
import Settings from '@/pages/app/Settings';
import AuthLayout from '@/pages/auth/AuthLayout';
import Login from '@/pages/auth/Login';
import Register from '@/pages/auth/Register';
import AuthCallback from '@/pages/auth/AuthCallback';
import ProtectedRoute from '@/components/shared/ProtectedRoute';

export default function App() {
  return (
    <Routes>
      {/* Landing page */}
      <Route path="/" element={<Landing />} />
      <Route path="/landing2" element={<Landing2 />} />

      {/* Auth routes */}
      <Route path="/auth" element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
      </Route>
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Protected app routes */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<MonthlyXray />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="xray" element={<Navigate to="/app" replace />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="income-units" element={<IncomeUnits />} />
        <Route path="budgets" element={<Budgets />} />
        <Route path="credits" element={<Credits />} />
        <Route path="goals" element={<Goals />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="family" element={<Family />} />
        <Route path="business" element={<Business />} />
        <Route path="properties" element={<Properties />} />
        <Route path="personal-projects" element={<PersonalProjects />} />
        <Route path="couple" element={<Navigate to="/app/family" replace />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
